export const SUBMIT = "/";
export const SUBMIT_SUCCESS = "/success";
export const SUBMIT_ALREADY = "/success/already";
export const EXPIRY = "/expiry";
export const UNSUBSCRIBE = "/unsubscribe";
export const UNSUBSCRIBE_SUCCESS = "/unsubscribe/success";
